var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HiddenHorizontalScrollbar',{staticClass:"filter-bar__provider"},_vm._l((_vm.providers()),function(provider){return _c('div',{key:provider.shortName,staticClass:"filter-bar__provider__icon",class:{
			active: _vm.activeProviders[provider.shortName],
		}},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.toggle(provider.shortName)}}},[_c('ProviderIcon',{attrs:{"providerId":provider.packageId,"size":"provider_icon"}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }